import sendRequest from "@/libs/sendRequest"

const sub_category = {
    namespaced: true,
    state: {
        sub_category: {},
        sub_categories: [],
        error: false,
        last_page: null,
        total_pages: null
    },
    getters: {
        getSubCategory: (state) => state.sub_category,
        getSubCategories: (state) => state.sub_categories,
        getLastPage: (state) => state.last_page,
        getTotalPages: (state) => state.total_pages,
        getError: (state) => state.error
    },
    mutations: {
        setSubCategory: (state, payload) => state.sub_category = payload,
        setSubCategories: (state, payload) => state.sub_categories = payload,
        setLastPage: (state, payload) => state.last_page = payload,
        setTotalPages: (state, payload) => state.total_pages = payload,
        setError: (state, payload) => state.error = payload,
    },
    actions: {
        list: async({commit, dispatch, rootGetters}, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/sub_category/list', 'GET', null, query, custom_headers)
            if(response.success && response.data) {
                if(query.datatable) {
                    commit('setSubCategories', response.data.list.result)
                    commit('setTotalPages', response.data.list.total_pages)
                    commit('setLastPage', response.data.list.total_pages == query.page)
                } else {
                    commit('setSubCategories', response.data.list)
                }
                dispatch('hiddenLoading', null, { root: true })
            }
            else if(!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        },
        view: async({commit, dispatch, rootGetters}, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/sub_category/view', 'GET', null, query, custom_headers)
            if(response.success && response.data) {
                commit('setSubCategory', response.data.view)
                dispatch('hiddenLoading', null, { root: true })
            }
            else if(!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        },
        add: async({commit, dispatch, rootGetters}, body) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/sub_category/add', 'POST', body, null, custom_headers)
            if(response.success && response.data) {
                dispatch('showAlert', 'The subcategory has been added successfully', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_id_category': messages.push('Error: Please select a category.'); break
                        case 'error_empty_name_sub_category': messages.push('Error: Please add a subcategory name.'); break
                        case 'error_sub_category_already_exists': messages.push('Error: The subcategory already exists.'); break
                        default: messages.push('An error has occurred try later'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        },
        update: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/sub_category/update', 'PUT', data.body, data.query, custom_headers)
            if(response.success && response.data) {
                dispatch('showAlert', 'Subcategory updated successfully', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_name_sub_category': messages.push('Error: Please add a subcategory name.'); break
                        case 'error_sub_category_inactive': messages.push('Error: Subcategory is inactive.'); break
                        case 'error_sub_category_already_exists': messages.push('Error: The subcategory already exists.'); break
                        default: messages.push('An error has occurred try later'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        },
        delete: async({commit, dispatch, rootGetters}, id) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/sub_category/delete', 'DELETE', null, { id_sub_category: id }, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'The subcategory has been successfully removed', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        }
    }
}

export default sub_category
